export const useDocumentZoomControllStore = (documentId: string) => {
  return useDocumentZoomControl(documentId)();
};
